import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-input-date',
  templateUrl: './input-date.component.html',
  styleUrls: ['./input-date.component.scss']
})
export class InputDateComponent {
  @Input() form: FormGroup;

  get months(): number[] {
    return Array(12).fill(null).map((_, index) => index + 1);
  }
}
